export default __webpack_public_path__ + "static/media/Mensaje_impacto_mundo4_2.94ea1c4e.png";